import VueViewer from 'v-viewer'
import { defineNuxtPlugin } from '#app'
import 'viewerjs/dist/viewer.css'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueViewer, {
        defaultOptions: {
            rotatable: true,
            movable: false,
            slideOnTouch: true,
            title: false,
            transition: false,
        },
    })
})
